"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getIsPdf = exports.getIsImage = void 0;
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var utils_1 = __importDefault(require("@nexys/utils"));
var widthDefault = 500;
exports.getIsImage = function (contentType) {
    return contentType.slice(0, 5) === 'image';
};
exports.getIsPdf = function (contentType) {
    return contentType === 'application/pdf';
};
var Display = function (_a) {
    var file = _a.file, onSend = _a.onSend, _b = _a.width, width = _b === void 0 ? widthDefault : _b;
    var _c = react_1["default"].useState(false), sendDisabled = _c[0], setSendDisabled = _c[1];
    var name = file.name, type = file.type, size = file.size;
    var isImage = exports.getIsImage(type);
    var isPdf = exports.getIsPdf(type);
    if (!isImage && !isPdf) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, "file could not be recognized");
    }
    var objectUrl = URL.createObjectURL(file);
    var handleSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pfileBuffer;
        return __generator(this, function (_a) {
            setSendDisabled(true);
            pfileBuffer = file.arrayBuffer();
            pfileBuffer.then(function (fileBuffer) {
                var b64 = utils_1["default"].buffer.arrayBufferTo64(fileBuffer);
                onSend && onSend(b64).then(function (x) { return setSendDisabled(false); });
            });
            return [2];
        });
    }); };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(Typography_1["default"], null,
            react_1["default"].createElement("strong", null, name)),
        react_1["default"].createElement(Typography_1["default"], null,
            utils_1["default"].string.formatSize(size),
            " - ",
            type),
        isImage && react_1["default"].createElement("img", { alt: name, width: width, src: objectUrl }),
        isPdf && (react_1["default"].createElement("iframe", { title: name, src: objectUrl, width: width, height: "375" })),
        onSend && (react_1["default"].createElement("button", { onClick: handleSend, disabled: sendDisabled }, "Send"))));
};
exports["default"] = Display;
